import { CloudUtils, Product } from '@portal/portal-core';
import * as ProductTabConstants from 'constants/product-tab';

// Boundary: getCurrentQueryParams() is typed as `{}` by cloud-core, but at
// runtime it may carry the legacy `product` and current `productName` params.
interface ProductQueryParams {
  product?: string;
  productName?: string;
}

// TODO - `product` is what the URI used to be for what is now `productName`
// This is a temporary fix to allow for backwards compatibility
// Remove `product` once there are no active invites older than the day this code is shipped to production
const { product, productName } =
  CloudUtils.getCurrentQueryParams() as ProductQueryParams;

export const lowerCaseObjectKeys = (
  obj: Record<string, string>,
): Record<string, string> =>
  Object.entries(obj).reduce<Record<string, string>>((acc, [key, value]) => {
    acc[key.toLowerCase()] = value;
    return acc;
  }, {});

const lowercaseKeysUiTabs = lowerCaseObjectKeys(Product.NAMES_UI_TABS);

const selectedProductTab =
  lowercaseKeysUiTabs[productName?.toLowerCase() ?? ''] ||
  lowercaseKeysUiTabs[product?.toLowerCase() ?? ''] || // TODO - this too is temporary. See line 4
  Product.NAMES_UI_TABS.flowJo;

interface ProductTabState {
  selectedProductTab: string;
  buyProduct?: unknown;
}

const initialState: ProductTabState = {
  selectedProductTab,
};

interface SelectedProductTabAction {
  type: typeof ProductTabConstants.SELECTED_PRODUCT_TAB;
  selectedProductTab?: string;
}

interface BuyProductAction {
  type: typeof ProductTabConstants.BUY_PRODUCT;
  product?: unknown;
}

type ProductTabAction =
  | SelectedProductTabAction
  | BuyProductAction
  | { type: string };

export default function ProductTab(
  state: ProductTabState = initialState,
  action: ProductTabAction,
): ProductTabState {
  switch (action.type) {
    case ProductTabConstants.SELECTED_PRODUCT_TAB:
      return {
        ...state,
        selectedProductTab:
          lowercaseKeysUiTabs[
            (action as SelectedProductTabAction).selectedProductTab?.toLowerCase() ??
            ''
          ],
      };
    case ProductTabConstants.BUY_PRODUCT:
      return {
        ...state,
        buyProduct: (action as BuyProductAction).product,
      };
    default:
      return state;
  }
}
